import { render } from "./AlarmCheckPermissionEditorCmp.vue?vue&type=template&id=06c6d010"
import script from "./AlarmCheckPermissionEditorCmp.vue?vue&type=script&lang=js"
export * from "./AlarmCheckPermissionEditorCmp.vue?vue&type=script&lang=js"

import "./AlarmCheckPermissionEditorCmp.vue?vue&type=style&index=0&id=06c6d010&lang=scss"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__